import { jsx } from 'react/jsx-runtime';
import { MultiselectTags } from '../../../tags/components/MultiselectTags.js';
import { useResourceListPreferencesContext } from '../ResourceList/contexts/resourceListContextPreferences.js';
import { useAuthStatus } from '@fabric-app/compat';

const ResourceFilterTag = ({ disabled = false }) => {
  const { filters, setFilterTagIds } = useResourceListPreferencesContext();
  const authStatus = useAuthStatus();
  if (authStatus !== "authenticated") {
    return null;
  }
  return /* @__PURE__ */ jsx(MultiselectTags, {
    disabled,
    value: filters.tagIds,
    onChange: setFilterTagIds
  });
};

export { ResourceFilterTag };
//# sourceMappingURL=ResourceFilterTag.js.map
